export const departments = [
    {value: '01', name: '01 (Ain)'},
    {value: '02', name: '02 (Aisne)'},
    {value: '03', name: '03 (Allier)'},
    {value: '04', name: '04 (Alpes-de-Haute-Provence)'},
    {value: '05', name: '05 (Hautes-Alpes)'},
    {value: '06', name: '06 (Alpes-Maritimes)'},
    {value: '07', name: '07 (Ardèche)'},
    {value: '08', name: '08 (Ardennes)'},
    {value: '09', name: '09 (Ariège)'},
    {value: '10', name: '10 (Aube)'},
    {value: '11', name: '11 (Aude)'},
    {value: '12', name: '12 (Aveyron)'},
    {value: '13', name: '13 (Bouches-du-Rhône)'},
    {value: '14', name: '14 (Calvados)'},
    {value: '15', name: '15 (Cantal)'},
    {value: '16', name: '16 (Charente)'},
    {value: '17', name: '17 (Charente-Maritime)'},
    {value: '18', name: '18 (Cher)'},
    {value: '19', name: '19 (Corrèze)'},
    {value: '2A', name: '2A (Corse-du-Sud)'},
    {value: '2B', name: '2B (Haute-Corse)'},
    {value: '21', name: '21 (Côte-d\'Or)'},
    {value: '22', name: '22 (Côtes-d\'Armor)'},
    {value: '23', name: '23 (Creuse)'},
    {value: '24', name: '24 (Dordogne)'},
    {value: '25', name: '25 (Doubs)'},
    {value: '26', name: '26 (Drôme)'},
    {value: '27', name: '27 (Eure)'},
    {value: '28', name: '28 (Eure-et-Loir)'},
    {value: '29', name: '29 (Finistère)'},
    {value: '30', name: '30 (Gard)'},
    {value: '31', name: '31 (Haute-Garonne)'},
    {value: '32', name: '32 (Gers)'},
    {value: '33', name: '33 (Gironde)'},
    {value: '34', name: '34 (Hérault)'},
    {value: '35', name: '35 (Ille-et-Vilaine)'},
    {value: '36', name: '36 (Indre)'},
    {value: '37', name: '37 (Indre-et-Loire)'},
    {value: '38', name: '38 (Isère)'},
    {value: '39', name: '39 (Jura)'},
    {value: '40', name: '40 (Landes)'},
    {value: '41', name: '41 (Loir-et-Cher)'},
    {value: '42', name: '42 (Loire)'},
    {value: '43', name: '43 (Haute-Loire)'},
    {value: '44', name: '44 (Loire-Atlantique)'},
    {value: '45', name: '45 (Loiret)'},
    {value: '46', name: '46 (Lot)'},
    {value: '47', name: '47 (Lot-et-Garonne)'},
    {value: '48', name: '48 (Lozère)'},
    {value: '49', name: '49 (Maine-et-Loire)'},
    {value: '50', name: '50 (Manche)'},
    {value: '51', name: '51 (Marne)'},
    {value: '52', name: '52 (Haute-Marne)'},
    {value: '53', name: '53 (Mayenne)'},
    {value: '54', name: '54 (Meurthe-et-Moselle)'},
    {value: '55', name: '55 (Meuse)'},
    {value: '56', name: '56 (Morbihan)'},
    {value: '57', name: '57 (Moselle)'},
    {value: '58', name: '58 (Nièvre)'},
    {value: '59', name: '59 (Nord)'},
    {value: '60', name: '60 (Oise)'},
    {value: '61', name: '61 (Orne)'},
    {value: '62', name: '62 (Pas-de-Calais)'},
    {value: '63', name: '63 (Puy-de-Dôme)'},
    {value: '64', name: '64 (Pyrénées-Atlantiques)'},
    {value: '65', name: '65 (Hautes-Pyrénées)'},
    {value: '66', name: '66 (Pyrénées-Orientales)'},
    {value: '67', name: '67 (Bas-Rhin)'},
    {value: '68', name: '68 (Haut-Rhin)'},
    {value: '69', name: '69 (Rhône)'},
    {value: '70', name: '70 (Haute-Saône)'},
    {value: '71', name: '71 (Saône-et-Loire)'},
    {value: '72', name: '72 (Sarthe)'},
    {value: '73', name: '73 (Savoie)'},
    {value: '74', name: '74 (Haute-Savoie)'},
    {value: '75', name: '75 (Paris)'},
    {value: '76', name: '76 (Seine-Maritime)'},
    {value: '77', name: '77 (Seine-et-Marne)'},
    {value: '78', name: '78 (Yvelines)'},
    {value: '79', name: '79 (Deux-Sèvres)'},
    {value: '80', name: '80 (Somme)'},
    {value: '81', name: '81 (Tarn)'},
    {value: '82', name: '82 (Tarn-et-Garonne)'},
    {value: '83', name: '83 (Var)'},
    {value: '84', name: '84 (Vaucluse)'},
    {value: '85', name: '85 (Vendée)'},
    {value: '86', name: '86 (Vienne)'},
    {value: '87', name: '87 (Haute-Vienne)'},
    {value: '88', name: '88 (Vosges)'},
    {value: '89', name: '89 (Yonne)'},
    {value: '90', name: '90 (Territoire de Belfort)'},
    {value: '91', name: '91 (Essonne)'},
    {value: '92', name: '92 (Hauts-de-Seine)'},
    {value: '93', name: '93 (Seine-Saint-Denis)'},
    {value: '94', name: '94 (Val-de-Marne)'},
    {value: '95', name: '95 (Val-d\'Oise)'},
    {value: '971', name: '971 (Guadeloupe)'},
    {value: '972', name: '972 (Martinique)'},
    {value: '973', name: '973 (Guyane)'},
    {value: '974', name: '974 (La Réunion)'},
    {value: '975', name: '975 (Saint-Pierre-et-Miquelon)'},
    {value: '976', name: '976 (Mayotte)'},
    {value: '977', name: '977 (Saint-Barthélemy)'},
    {value: '978', name: '978 (Saint-Martin)'},
    {value: '984', name: '984 (Terres australes et antarctiques françaises)'},
    {value: '986', name: '986 (Wallis et Futuna)'},
    {value: '987', name: '987 (Polynésie française)'},
    {value: '988', name: '988 (Nouvelle-Calédonie)'},
    {value: '99', name: '99 (Étranger)'},
];


export const company_type = [
    {name: 'SARL - Société à Responsabilité Limitée', value: 'SARL'},
    {name: 'SAS / SASU - Société par Actions Simplifiée (Unipersonnelle)', value: 'SAS'},
    {name: 'SA - Société Anonyme', value: 'SA'},
    {name: 'SCI - Société Civile Immobilière', value: 'SCI'},
    {name: 'SCCV - Société Civile de Construction Vente', value: 'SCCV'},
    {name: 'SCP - Société Civile Professionnelle', value: 'SCP'},
    {name: 'SEL - Société d’Exercice Libéral (SELARL, SELAS, …)', value: 'SEL'},
    {name: 'EI - Entrepreneur Individuel', value: 'EI'},
    {name: 'EURL - Entreprise Unipersonnelle à Responsabilité Limitée', value: 'EURL'},
    {name: 'SCA - Société en Commandite par Actions', value: 'SCA'},
    {name: 'SCS - Société en Commandite Simple', value: 'SCS'},
    {name: 'SNC - Société en Nom Collectif', value: 'SNC'},
    {name: 'Société Agricole (SCEA, GAEC, EARL, …)', value: 'Société Agricole'},
    {name: 'Autre société', value: 'N/A'},
    {name: 'Société étrangère', value: 'Société étrangère'},
]

export const nationalities = [
    {value: "FR", name: "France 🇫🇷"},
    {value: "AF", name: "Afghanistan 🇦🇫"},
    {value: "ZA", name: "Afrique du Sud 🇿🇦"},
    {value: "AL", name: "Albanie 🇦🇱"},
    {value: "DZ", name: "Algérie 🇩🇿"},
    {value: "DE", name: "Allemagne 🇩🇪"},
    {value: "AD", name: "Andorre 🇦🇩"},
    {value: "AO", name: "Angola 🇦🇴"},
    {value: "AI", name: "Anguilla 🇦🇮"},
    {value: "AQ", name: "Antarctique 🇦🇶"},
    {value: "AG", name: "Antigua-et-Barbuda 🇦🇬"},
    {value: "SA", name: "Arabie saoudite 🇸🇦"},
    {value: "AR", name: "Argentine 🇦🇷"},
    {value: "AM", name: "Arménie 🇦🇲"},
    {value: "AW", name: "Aruba 🇦🇼"},
    {value: "AU", name: "Australie 🇦🇺"},
    {value: "AT", name: "Autriche 🇦🇹"},
    {value: "AZ", name: "Azerbaïdjan 🇦🇿"},
    {value: "BS", name: "Bahamas 🇧🇸"},
    {value: "BH", name: "Bahreïn 🇧🇭"},
    {value: "BD", name: "Bangladesh 🇧🇩"},
    {value: "BB", name: "Barbade 🇧🇧"},
    {value: "BE", name: "Belgique 🇧🇪"},
    {value: "BZ", name: "Belize 🇧🇿"},
    {value: "BJ", name: "Bénin 🇧🇯"},
    {value: "BM", name: "Bermudes 🇧🇲"},
    {value: "BT", name: "Bhoutan 🇧🇹"},
    {value: "BY", name: "Biélorussie 🇧🇾"},
    {value: "BO", name: "Bolivie 🇧🇴"},
    {value: "BQ", name: "Bonaire, Saint-Eustache et Saba 🇧🇶"},
    {value: "BA", name: "Bosnie-Herzégovine 🇧🇦"},
    {value: "BW", name: "Botswana 🇧🇼"},
    {value: "BR", name: "Brésil 🇧🇷"},
    {value: "BN", name: "Brunéi Darussalam 🇧🇳"},
    {value: "BG", name: "Bulgarie 🇧🇬"},
    {value: "BF", name: "Burkina Faso 🇧🇫"},
    {value: "BI", name: "Burundi 🇧🇮"},
    {value: "KH", name: "Cambodge 🇰🇭"},
    {value: "CM", name: "Cameroun 🇨🇲"},
    {value: "CA", name: "Canada 🇨🇦"},
    {value: "CV", name: "Cap-Vert 🇨🇻"},
    {value: "CL", name: "Chili 🇨🇱"},
    {value: "CN", name: "Chine 🇨🇳"},
    {value: "CY", name: "Chypre 🇨🇾"},
    {value: "CO", name: "Colombie 🇨🇴"},
    {value: "KM", name: "Comores 🇰🇲"},
    {value: "CG", name: "Congo 🇨🇬"},
    {value: "KR", name: "Corée 🇰🇷"},
    {value: "KP", name: "Corée du Nord 🇰🇵"},
    {value: "CR", name: "Costa Rica 🇨🇷"},
    {value: "CI", name: "Côte d'Ivoire 🇨🇮"},
    {value: "HR", name: "Croatie 🇭🇷"},
    {value: "CU", name: "Cuba 🇨🇺"},
    {value: "CW", name: "Curaçao 🇨🇼"},
    {value: "DK", name: "Danemark 🇩🇰"},
    {value: "DJ", name: "Djibouti 🇩🇯"},
    {value: "DM", name: "Dominique 🇩🇲"},
    {value: "EG", name: "Égypte 🇪🇬"},
    {value: "SV", name: "El Salvador 🇸🇻"},
    {value: "AE", name: "Émirats arabes unis 🇦🇪"},
    {value: "EC", name: "Équateur 🇪🇨"},
    {value: "ER", name: "Érythrée 🇪🇷"},
    {value: "ES", name: "Espagne 🇪🇸"},
    {value: "EE", name: "Estonie 🇪🇪"},
    {value: "SZ", name: "Eswatini 🇸🇿"},
    {value: "VA", name: "État de la Cité du Vatican 🇻🇦"},
    {value: "US", name: "États-Unis 🇺🇸"},
    {value: "ET", name: "Éthiopie 🇪🇹"},
    {value: "FJ", name: "Fidji 🇫🇯"},
    {value: "FI", name: "Finlande 🇫🇮"},
    {value: "GA", name: "Gabon 🇬🇦"},
    {value: "GM", name: "Gambie 🇬🇲"},
    {value: "GE", name: "Géorgie 🇬🇪"},
    {value: "GH", name: "Ghana 🇬🇭"},
    {value: "GI", name: "Gibraltar 🇬🇮"},
    {value: "GR", name: "Grèce 🇬🇷"},
    {value: "GD", name: "Grenade 🇬🇩"},
    {value: "GL", name: "Groenland 🇬🇱"},
    {value: "GP", name: "Guadeloupe 🇬🇵"},
    {value: "GU", name: "Guam 🇬🇺"},
    {value: "GT", name: "Guatemala 🇬🇹"},
    {value: "GG", name: "Guernesey 🇬🇬"},
    {value: "GN", name: "Guinée 🇬🇳"},
    {value: "GQ", name: "Guinée équatoriale 🇬🇶"},
    {value: "GW", name: "Guinée-Bissau 🇬🇼"},
    {value: "GY", name: "Guyana 🇬🇾"},
    {value: "GF", name: "Guyane française 🇬🇫"},
    {value: "HT", name: "Haïti 🇭🇹"},
    {value: "HN", name: "Honduras 🇭🇳"},
    {value: "HK", name: "Hong Kong 🇭🇰"},
    {value: "HU", name: "Hongrie 🇭🇺"},
    {value: "CX", name: "Île Christmas 🇨🇽"},
    {value: "IM", name: "Île de Man 🇮🇲"},
    {value: "NF", name: "Île Norfolk 🇳🇫"},
    {value: "KY", name: "Îles Caïmans 🇰🇾"},
    {value: "CC", name: "Îles Cocos (Keeling) 🇨🇨"},
    {value: "FK", name: "Îles Falkland (Malvinas) 🇫🇰"},
    {value: "FO", name: "Îles Féroé 🇫🇴"},
    {value: "MP", name: "Îles Mariannes du Nord 🇲🇵"},
    {value: "MH", name: "Îles Marshall 🇲🇭"},
    {value: "SB", name: "Îles Salomon 🇸🇧"},
    {value: "VG", name: "Îles Vierges britanniques 🇻🇬"},
    {value: "VI", name: "Îles Vierges des États-Unis 🇻🇮"},
    {value: "IN", name: "Inde 🇮🇳"},
    {value: "ID", name: "Indonésie 🇮🇩"},
    {value: "IQ", name: "Irak 🇮🇶"},
    {value: "IR", name: "Iran 🇮🇷"},
    {value: "IE", name: "Irlande 🇮🇪"},
    {value: "IS", name: "Islande 🇮🇸"},
    {value: "IL", name: "Israël 🇮🇱"},
    {value: "IT", name: "Italie 🇮🇹"},
    {value: "JM", name: "Jamaïque 🇯🇲"},
    {value: "JP", name: "Japon 🇯🇵"},
    {value: "JE", name: "Jersey 🇯🇪"},
    {value: "JO", name: "Jordanie 🇯🇴"},
    {value: "KZ", name: "Kazakhstan 🇰🇿"},
    {value: "KE", name: "Kenya 🇰🇪"},
    {value: "KG", name: "Kirghizistan 🇰🇬"},
    {value: "KI", name: "Kiribati 🇰🇮"},
    {value: "XK", name: "Kosovo 🇽🇰"},
    {value: "KW", name: "Koweït 🇰🇼"},
    {value: "LA", name: "Laos 🇱🇦"},
    {value: "LS", name: "Lesotho 🇱🇸"},
    {value: "LV", name: "Lettonie 🇱🇻"},
    {value: "LB", name: "Liban 🇱🇧"},
    {value: "LR", name: "Libéria 🇱🇷"},
    {value: "LY", name: "Libye 🇱🇾"},
    {value: "LI", name: "Liechtenstein 🇱🇮"},
    {value: "LT", name: "Lituanie 🇱🇹"},
    {value: "LU", name: "Luxembourg 🇱🇺"},
    {value: "MO", name: "Macao 🇲🇴"},
    {value: "MK", name: "Macédoine du Nord 🇲🇰"},
    {value: "MG", name: "Madagascar 🇲🇬"},
    {value: "MY", name: "Malaisie 🇲🇾"},
    {value: "MW", name: "Malawi 🇲🇼"},
    {value: "MV", name: "Maldives 🇲🇻"},
    {value: "ML", name: "Mali 🇲🇱"},
    {value: "MT", name: "Malte 🇲🇹"},
    {value: "MA", name: "Maroc 🇲🇦"},
    {value: "MQ", name: "Martinique 🇲🇶"},
    {value: "MU", name: "Maurice 🇲🇺"},
    {value: "MR", name: "Mauritanie 🇲🇷"},
    {value: "YT", name: "Mayotte 🇾🇹"},
    {value: "MX", name: "Mexique 🇲🇽"},
    {value: "FM", name: "Micronésie 🇫🇲"},
    {value: "MD", name: "Moldavie 🇲🇩"},
    {value: "MC", name: "Monaco 🇲🇨"},
    {value: "MN", name: "Mongolie 🇲🇳"},
    {value: "ME", name: "Monténégro 🇲🇪"},
    {value: "MS", name: "Montserrat 🇲🇸"},
    {value: "MZ", name: "Mozambique 🇲🇿"},
    {value: "MM", name: "Myanmar 🇲🇲"},
    {value: "NA", name: "Namibie 🇳🇦"},
    {value: "NR", name: "Nauru 🇳🇷"},
    {value: "NP", name: "Népal 🇳🇵"},
    {value: "NI", name: "Nicaragua 🇳🇮"},
    {value: "NE", name: "Niger 🇳🇪"},
    {value: "NG", name: "Nigéria 🇳🇬"},
    {value: "NU", name: "Niue 🇳🇺"},
    {value: "NO", name: "Norvège 🇳🇴"},
    {value: "NC", name: "Nouvelle-Calédonie 🇳🇨"},
    {value: "NZ", name: "Nouvelle-Zélande 🇳🇿"},
    {value: "OM", name: "Oman 🇴🇲"},
    {value: "UG", name: "Ouganda 🇺🇬"},
    {value: "UZ", name: "Ouzbékistan 🇺🇿"},
    {value: "PK", name: "Pakistan 🇵🇰"},
    {value: "PW", name: "Palaos 🇵🇼"},
    {value: "PS", name: "Palestine 🇵🇸"},
    {value: "PA", name: "Panama 🇵🇦"},
    {value: "PG", name: "Papouasie-Nouvelle-Guinée 🇵🇬"},
    {value: "PY", name: "Paraguay 🇵🇾"},
    {value: "NL", name: "Pays-Bas 🇳🇱"},
    {value: "PE", name: "Pérou 🇵🇪"},
    {value: "PH", name: "Philippines 🇵🇭"},
    {value: "PN", name: "Pitcairn 🇵🇳"},
    {value: "PL", name: "Pologne 🇵🇱"},
    {value: "PF", name: "Polynésie française 🇵🇫"},
    {value: "PR", name: "Porto Rico 🇵🇷"},
    {value: "PT", name: "Portugal 🇵🇹"},
    {value: "QA", name: "Qatar 🇶🇦"},
    {value: "CF", name: "République centrafricaine 🇨🇫"},
    {value: "CD", name: "République démocratique du Congo 🇨🇩"},
    {value: "DO", name: "République dominicaine 🇩🇴"},
    {value: "CZ", name: "République tchèque 🇨🇿"},
    {value: "RE", name: "Réunion 🇷🇪"},
    {value: "RO", name: "Roumanie 🇷🇴"},
    {value: "GB", name: "Royaume-Uni 🇬🇧"},
    {value: "RU", name: "Russie 🇷🇺"},
    {value: "RW", name: "Rwanda 🇷🇼"},
    {value: "EH", name: "Sahara occidental 🇪🇭"},
    {value: "BL", name: "Saint-Barthélemy 🇧🇱"},
    {value: "KN", name: "Saint-Kitts-et-Nevis 🇰🇳"},
    {value: "SM", name: "Saint-Marin 🇸🇲"},
    {value: "MF", name: "Saint-Martin (partie française) 🇲🇫"},
    {value: "SX", name: "Saint-Martin (partie néerlandaise) 🇸🇽"},
    {value: "PM", name: "Saint-Pierre-et-Miquelon 🇵🇲"},
    {value: "VC", name: "Saint-Vincent-et-les Grenadines 🇻🇨"},
    {value: "LC", name: "Sainte-Lucie 🇱🇨"},
    {value: "WS", name: "Samoa 🇼🇸"},
    {value: "AS", name: "Samoa américaines 🇦🇸"},
    {value: "ST", name: "Sao Tomé-et-Principe 🇸🇹"},
    {value: "SN", name: "Sénégal 🇸🇳"},
    {value: "RS", name: "Serbie 🇷🇸"},
    {value: "SC", name: "Seychelles 🇸🇨"},
    {value: "SL", name: "Sierra Leone 🇸🇱"},
    {value: "SG", name: "Singapour 🇸🇬"},
    {value: "SK", name: "Slovaquie 🇸🇰"},
    {value: "SI", name: "Slovénie 🇸🇮"},
    {value: "SO", name: "Somalie 🇸🇴"},
    {value: "SD", name: "Soudan 🇸🇩"},
    {value: "SS", name: "Soudan du Sud 🇸🇸"},
    {value: "LK", name: "Sri Lanka 🇱🇰"},
    {value: "SE", name: "Suède 🇸🇪"},
    {value: "CH", name: "Suisse 🇨🇭"},
    {value: "SR", name: "Suriname 🇸🇷"},
    {value: "SY", name: "Syrie 🇸🇾"},
    {value: "TJ", name: "Tadjikistan 🇹🇯"},
    {value: "TW", name: "Taïwan 🇹🇼"},
    {value: "TZ", name: "Tanzanie 🇹🇿"},
    {value: "TD", name: "Tchad 🇹🇩"},
    {value: "TF", name: "Terres australes françaises 🇹🇫"},
    {value: "TH", name: "Thaïlande 🇹🇭"},
    {value: "TL", name: "Timor-Leste 🇹🇱"},
    {value: "TG", name: "Togo 🇹🇬"},
    {value: "TK", name: "Tokelau 🇹🇰"},
    {value: "TO", name: "Tonga 🇹🇴"},
    {value: "TT", name: "Trinité-et-Tobago 🇹🇹"},
    {value: "TN", name: "Tunisie 🇹🇳"},
    {value: "TM", name: "Turkménistan 🇹🇲"},
    {value: "TR", name: "Turquie 🇹🇷"},
    {value: "TV", name: "Tuvalu 🇹🇻"},
    {value: "UA", name: "Ukraine 🇺🇦"},
    {value: "UY", name: "Uruguay 🇺🇾"},
    {value: "VU", name: "Vanuatu 🇻🇺"},
    {value: "VE", name: "Venezuela 🇻🇪"},
    {value: "VN", name: "Viêt Nam 🇻🇳"},
    {value: "WF", name: "Wallis-et-Futuna 🇼🇫"},
    {value: "YE", name: "Yémen 🇾🇪"},
    {value: "ZM", name: "Zambie 🇿🇲"},
    {value: "ZW", name: "Zimbabwe 🇿🇼"},
];

export function getCountryNameFromCountryIso2Value(value) {
    if (!value) return null;
    const nationality = nationalities.find(nat => nat.value.toLowerCase() === value.toLowerCase());
    return nationality ? nationality.name : null;
}

// Pays à risque (liste UE/GAFI) - codes ISO2
export const riskCountries = new Set([
    'AF', 'DZ', 'AS', 'AO', 'AI', 'AG', 'BS', 'BB', 'BZ', 'BO', 'BG', 'BF', 'CM',
    'CD', 'CI', 'HR', 'FJ', 'GI', 'GU', 'HT', 'IR', 'JM', 'KE', 'KW', 'LA', 'LB',
    'ML', 'MC', 'MZ', 'MM', 'NA', 'NP', 'NG', 'KP', 'PW', 'PA', 'PG', 'PH', 'RU',
    'WS', 'SN', 'SC', 'ZA', 'SS', 'SY', 'TZ', 'TT', 'TC', 'UG', 'AE', 'VU', 'VE',
    'VN', 'VI', 'YE',
]);

export function isRiskCountry(isoCode) {
    if (!isoCode) return false;
    return riskCountries.has(isoCode.toUpperCase());
}

export const ProjectStatus = {
    ARCHIVER: "ARCHIVER",
    ATTENTE_CLOTURE_COMPTABLE: "ATTENTE_CLOTURE_COMPTABLE",
    CLOTURER: "CLOTURER",
    EN_ATTENTE: "EN_ATTENTE",
    EN_COURS: "EN_COURS",
    SIGNER: "SIGNER",
    SUPPRIMER: "SUPPRIMER",
}

export const statuses = [
    {label: "🗄️  Tous", value: 'ALL'},
    {label: "⏸️️  En attente", value: ProjectStatus.EN_ATTENTE},
    {label: "📂  En cours", value: ProjectStatus.EN_COURS},
    {label: "🕰️  Attente clôture comptable", value: ProjectStatus.ATTENTE_CLOTURE_COMPTABLE},
    {label: "✔️  Clôturés", value: ProjectStatus.CLOTURER},
    {label: "📚  Archivés", value: ProjectStatus.ARCHIVER},
];

export const statusFolder = [
    {label: "📂  En cours", value: ProjectStatus.EN_COURS},
    {label: "⏸️️  En attente", value: ProjectStatus.EN_ATTENTE},
    {label: "🕰️  Attente clôture comptable", value: ProjectStatus.ATTENTE_CLOTURE_COMPTABLE},
    {label: "✔️  Clôturé", value: ProjectStatus.CLOTURER},
    {label: "📚  Archivé", value: ProjectStatus.ARCHIVER},
];

export const states = [
    {value: 'all', label: '🔵 Tous'},
    {value: 'nothing', label: '🟢 Vert'},
    {value: 'warning', label: '🟠 Orange'},
    {value: 'danger', label: '🔴 Rouge'},
];

export const ResultType = Object.freeze({
    ANALYSE_IA: 'Analyse Automatique',
    ANNONCES_COMMERCIALES: "Annonces commerciales",
    BENEFICIAIRES_EFFECTIF: "Bénéficiaire effectif des sociétés",
    CONCORDANCE_SOCIETE: "Concordances avec des sociétés",
    FICHE_IDENTITE_SOCIETE: "Fiche d'identité de la société",
    GEL_AVOIRS: "Gels des avoirs",
    GEL_IMMOBILIER: "Gel des biens immobiliers",
    PAYS_A_RISQUE: "Pays à risque selon l'UE",
    PPE: "Personnes Politiquement Exposées",
    RETABLISSEMENTS_PERSONNELS: "Rétablissements personnels",
    RNE_INPI: "Registre National des Entreprises (INPI)",
    SANCTIONS_INTERNATIONALES: "Sanctions internationales",
    RISK_COMPLIANCE_DOWJONES: 'Dow Jones Risk & Compliance',
    RISK_COMPLIANCE_DOWJONES_SCREENING: 'Dow Jones Screening & Monitoring',
    GOOGLE_SEARCH: 'Recherche Google',
    OFFSHORE_LEAKS: 'Offshore leaks',
});

export const MentionType = Object.freeze({
    COMPANY_FOUND: "company_found",
    ERROR: "error",
    INDETERMINATE: 'indeterminate',
    MENTION: "mention",
    MENTION_FOUND: "mention_found",
    NOTHING: "nothing",
    NULL: "null",
    TO_VERIFY: "to_verify",
    TO_VERIFY_COMPANY: "to_verify_company",
    WARNING: "warning",
});